export default function initHhBanner() {
  var banner = document.querySelector('.js-hh-banner');

  if (!banner) {
    return;
  }

  function hideBanner() {
    banner.classList.add('is-hidden');
    document.documentElement.classList.add('hh-banner-closed');
  }

  var closeBtn = banner.querySelector('.js-hh-banner-close');

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      hideBanner();
    });
  }
}



// WEBPACK FOOTER //
// ./_src/js/hh-banner.js